import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { BUTTON_LOADING_INDICATOR_TIMEOUT } from 'admin-panel/constants/ec-timeouts';
import { task, timeout } from 'ember-concurrency';

interface UiButtonLoadingIndicatorSignature {
  Args: {
    Named: {
      isLoading?: boolean;
    };
  };
  Blocks: {
    default: [];
    indicator: [];
    content: [];
  };
}

export default class UiButtonLoadingIndicatorComponent extends Component<UiButtonLoadingIndicatorSignature> {
  @tracked
  isLoadingDebounced = this.isLoading;

  get isLoading() {
    return !!this.args.isLoading;
  }

  debounceTask = task({ restartable: true }, async (value) => {
    if (value === false) {
      this.isLoadingDebounced = value;
      return;
    }

    await timeout(BUTTON_LOADING_INDICATOR_TIMEOUT);

    this.isLoadingDebounced = value;
  });
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Button::LoadingIndicator': typeof UiButtonLoadingIndicatorComponent;
    'ui/button/loading-indicator': typeof UiButtonLoadingIndicatorComponent;
  }
}
